import { client as xpClient, type UserPlans } from '@cfa/pathway-fe-shared/xp';

import { store as jotaiStore } from '@/atoms';
import { planResourceDebugMockAtom } from '@/atoms/planResourceDebugMock';
import { env } from '@/env';
import { applyPlanResourceDebugMock } from '@/routes/TrainingPlans/resourceError/applyPlanResourceDebugMock';

const PLAN_AND_ASSIGNMENTS_PATH = /^\/plans\/[^/]+$/;

/** Patches GET /plans/{planId} responses when the dev-menu mock is enabled. */
export const setupPlanResourceDebugMockInterceptor = (): void => {
  if (env.REACT_APP_ENV === 'prod') {
    return;
  }

  xpClient.interceptors.response.use(async (response, request) => {
    if (!response.ok || request.method !== 'GET') {
      return response;
    }

    const mockState = jotaiStore.get(planResourceDebugMockAtom);
    if (!mockState.enabled) {
      return response;
    }

    let pathname: string;
    try {
      pathname = new URL(request.url).pathname;
    } catch {
      return response;
    }

    if (!PLAN_AND_ASSIGNMENTS_PATH.test(pathname)) {
      return response;
    }

    const contentType = response.headers.get('content-type') ?? '';
    if (!contentType.includes('json')) {
      return response;
    }

    try {
      const body = (await response.clone().json()) as UserPlans;
      const patched = applyPlanResourceDebugMock(body, mockState.scenario);
      const headers = new Headers();
      headers.set('content-type', 'application/json');

      return new Response(JSON.stringify(patched), {
        status: response.status,
        statusText: response.statusText,
        headers,
      });
    } catch {
      return response;
    }
  });
};
